export default __webpack_public_path__ + "static/media/our-service-industrial-background.85d115d4.jpg";